import type React from 'react';
import { useId } from 'react';

import { Checkbox, Label, LabeledControl } from '@zillow/constellation-10';

type Props = {
  onBoxClick: (event: React.MouseEvent<HTMLInputElement>) => void;
  setSectionValues?: (keyValuePairs: object) => void;
  FIELD_NAME: string;
  LABEL: string;
  checked: boolean;
  controlId?: string;
};

export default function RulesCheckbox({ onBoxClick, FIELD_NAME, LABEL, checked, controlId }: Props): JSX.Element {
  const generatedId = useId();
  const id = controlId || generatedId;

  return (
    <LabeledControl
      controlId={id}
      label={<Label>{LABEL}</Label>}
      control={<Checkbox data-test="checkbox" onClick={onBoxClick} data-value={FIELD_NAME} checked={checked} />}
    />
  );
}
